import FixedQuestions from "../../components/FixedQuestions";

function FixedQuestionsPage() {
  return <FixedQuestions />;
}

export default FixedQuestionsPage;

